let jegyzokonyv = {
    intezmenyKod: '',
    karKod: '',
    tanszek: '',
    muhely: '',
    intezmenyiKonferencia: '',
    konferencia: '',
    idopont: '',
    helyszin: '',
    szekcio: '',
    palyamunkak: [],
    zsuritagok: [],
    loadResult: '',
    loadMessage: ''
};

let intezmenyekLoaded = false;
let intezmenyekJogviszony = [];
let intezmenyekAffiliacio = [];
let intezmenyekKonferencia = [];
let errorLog = [];

export default {
    getJegyzokonyv(app_name) {
        this.app_name = app_name;
        return jegyzokonyv;
    },

    createPalyamunka(jegyzokonyv) {
        let palyamunka = {
            cim: '',
            nyelv: '',
            osszesitettPontszam: 0,
            helyezes: 0,
            otdkraJavasolt: '',
            affiliacioTipus: '',
            felsooktatasiAffiliacio: {
                intezmenyKod: '',
                karKod: '',
            },
            kozepiskolaiAffiliacio: {
                kozepiskolaProgram: '',
            },
            zsuriMegjegyzes: '',
            sorrendRelevans: '',
            aranyRelevans: '',
            szerzok: [],
            temavezetok: []
        };

        jegyzokonyv.palyamunkak.push(palyamunka);
        return palyamunka;
    },

    createHallgato(palyamunka) {
        let hallgato = { 
            vezetekNev: '', 
            keresztNev: '',
            email: '', 
            omAzon: '',
            szerzosegiArany: 0.0,
            kozepiskolas: false,
            kozepiskolaiJogviszony: {
                kozepiskolaNev: '',
                kozepiskolaVaros: ''
            },
            felsooktatasiJogviszonyok: [] 
        };

        palyamunka.szerzok.push(hallgato);
        return hallgato;
    },

    createJogviszony(hallgato) {
        let jogviszony = {
            intezmenyKod: '',
            karKod: '',
            aktivFelevekSzama: '',
            kepzesTipusa: '',
            kepzesMunkarendje: '',
            megkezdesEve: ''
        }

        hallgato.felsooktatasiJogviszonyok.push(jogviszony);
        return jogviszony;
    },

    createTemavezeto(palyamunka) {
        let temavezeto = {
            titulus: '',
            vezetekNev: '',
            keresztNev: '',
            email: '',
            omAzon: '',
            munkahelyek: []
        };

        palyamunka.temavezetok.push(temavezeto);
        return temavezeto;
    },

    createZsuritag(jegyzokonyv) {
        let zsuritag = {
            titulus: '',
            vezetekNev: '',
            keresztNev: '',
            email: '',
            munkahelyek: []
        };

        jegyzokonyv.zsuritagok.push(zsuritag);
        return zsuritag;
    },

    createFelsooktatasiMunkahely(szemely) {
        let felsooktatasiMunkahely = {
            felsooktatas: true,
            beosztas: '',
            intezmenyKod: '',
            karKod: '',
        };

        szemely.munkahelyek.push(felsooktatasiMunkahely);
        return felsooktatasiMunkahely;
    },

    createEgyebMunkahely(szemely) {
        let egyebMunkahely = {
            felsooktatas: false,
            beosztas: '',
            munkahelyNev: ''
        };

        szemely.munkahelyek.push(egyebMunkahely);
        return egyebMunkahely;
    },

    loadJegyzokonyvXml(jegyzokonyv, text) {
        let logging = false;
        let parser = new DOMParser();
        let xml = parser.parseFromString(text, "text/xml");

        jegyzokonyv.intezmenyKod = xml.evaluate('/tdkKonferencia/konferenciaAdatai/intezmenyKod', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('IntezmenyKod:' + jegyzokonyv.intezmenyKod);
        
        jegyzokonyv.karKod = xml.evaluate('/tdkKonferencia/konferenciaAdatai/karKod', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('KarKod:' + jegyzokonyv.karKod);

        jegyzokonyv.tanszek = xml.evaluate('/tdkKonferencia/konferenciaAdatai/tanszek', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('Tanszek:' + jegyzokonyv.tanszek);

        jegyzokonyv.muhely = xml.evaluate('/tdkKonferencia/konferenciaAdatai/muhely', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('Muhely:' + jegyzokonyv.muhely);

        jegyzokonyv.intezmenyiKonferencia = xml.evaluate('/tdkKonferencia/konferenciaAdatai/intezmenyiKonferencia', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('Intezmenyi/kari konferencia:' + jegyzokonyv.intezmenyiKonferencia);

        jegyzokonyv.konferencia = xml.evaluate('/tdkKonferencia/konferenciaAdatai/konferencia', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('TDK-konferencia tagozat:' + jegyzokonyv.konferencia);

        jegyzokonyv.idopont = xml.evaluate('/tdkKonferencia/konferenciaAdatai/idopont', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('Idopont:' + jegyzokonyv.idopont);

        jegyzokonyv.helyszin = xml.evaluate('/tdkKonferencia/konferenciaAdatai/helyszin', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('Helyszin:' + jegyzokonyv.helyszin);

        jegyzokonyv.szekcio = xml.evaluate('/tdkKonferencia/konferenciaAdatai/szekcio', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (logging) console.log('Szekcio:' + jegyzokonyv.szekcio);

        jegyzokonyv.palyamunkak = []
        const palyamunkaIterator = xml.evaluate('//palyamunka', xml, null, XPathResult.ANY_TYPE, null);
        let palyamunkaXml = palyamunkaIterator.iterateNext();
        let palyamunkaI = 1;
        while (palyamunkaXml) {
            let palyamunka = this.createPalyamunka(jegyzokonyv);

            palyamunka.cim = xml.evaluate('cim', palyamunkaXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log(palyamunkaI + '. palyamunka: ' + palyamunka.cim);

            palyamunka.nyelv = xml.evaluate('nyelv', palyamunkaXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log('  Nyelv:' + palyamunka.nyelv);

            palyamunka.osszesitettPontszam = xml.evaluate('osszesitettPontszam', palyamunkaXml, null, XPathResult.NUMBER_TYPE, null).numberValue;
            if (logging) console.log('  OsszesitettPontszam:' + palyamunka.osszesitettPontszam);

            palyamunka.helyezes = xml.evaluate('helyezes', palyamunkaXml, null, XPathResult.NUMBER_TYPE, null).numberValue;
            if (logging) console.log('  Helyezes:' + palyamunka.helyezes);

            palyamunka.otdkraJavasolt = xml.evaluate('otdkraJavasolt', palyamunkaXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log('  OtdkraJavasolt:' + palyamunka.otdkraJavasolt);

            const kozepiskolaiAffiliacioIterator = xml.evaluate('kozepiskolaiAffiliacio', palyamunkaXml, null, XPathResult.ANY_TYPE, null);
            let kozepiskolaiAffiliacioXml = kozepiskolaiAffiliacioIterator.iterateNext();
            if (kozepiskolaiAffiliacioXml) {
                palyamunka.affiliacioTipus = 'K';
                palyamunka.kozepiskolaiAffiliacio.kozepiskolaProgram = xml.evaluate('kozepiskolaProgram', kozepiskolaiAffiliacioXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('    Kozepiskolas affiliacio: ' + palyamunka.kozepiskolaAffiliacio.kozepiskolaProgram);
            }

            const felsooktatasiAffiliacioIterator = xml.evaluate('felsooktatasiAffiliacio', palyamunkaXml, null, XPathResult.ANY_TYPE, null);
            let felsooktatasiAffiliacioXml = felsooktatasiAffiliacioIterator.iterateNext();
            if (felsooktatasiAffiliacioXml) {
                palyamunka.affiliacioTipus = 'F';
                palyamunka.felsooktatasiAffiliacio.intezmenyKod = xml.evaluate('intezmenyKod', felsooktatasiAffiliacioXml, null, XPathResult.STRING_TYPE, null).stringValue;
                palyamunka.felsooktatasiAffiliacio.karKod = xml.evaluate('karKod', felsooktatasiAffiliacioXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('    Felsooktatási affiliacio: ' + palyamunka.felsooktatasiAffiliacio.intezmenyKod + ' ' + palyamunka.felsooktatasiAffiliacio.karKod);
            }

            palyamunka.zsuriMegjegyzes = xml.evaluate('zsuriMegjegyzes', palyamunkaXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log('  ZsuriMegjegyzes:' + palyamunka.zsuriMegjegyzes);

            palyamunka.sorrendRelevans = xml.evaluate('sorrendRelevans', palyamunkaXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log('  SorrendRelevans:' + palyamunka.sorrendRelevans);

            palyamunka.aranyRelevans = xml.evaluate('aranyRelevans', palyamunkaXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log('  AranyRelevans:' + palyamunka.aranyRelevans);

            const hallgatoIterator = xml.evaluate('szerzok/hallgato', palyamunkaXml, null, XPathResult.ANY_TYPE, null);
            let hallgatoXml = hallgatoIterator.iterateNext();
            let hallgatoI = 0
            while (hallgatoXml) {
                let hallgato = this.createHallgato(palyamunka);

                hallgato.vezetekNev = xml.evaluate('vezetekNev', hallgatoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                hallgato.keresztNev = xml.evaluate('keresztNev', hallgatoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('  ' + hallgatoI + '. hallgato: ' + hallgato.vezetekNev +' '+ hallgato.keresztNev);

                hallgato.omAzon = xml.evaluate('omAzon', hallgatoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('    OmAzon:' + hallgato.omAzon);

                hallgato.email = xml.evaluate('email', hallgatoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('    E-mail:' + hallgato.email);

                hallgato.szerzosegiArany = xml.evaluate('szerzosegiArany', hallgatoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('    SzerzosegiArany:' + hallgato.szerzosegiArany);

                const kozepiskolaiJogviszonyIterator = xml.evaluate('kozepiskolaiJogviszony', hallgatoXml, null, XPathResult.ANY_TYPE, null);
                let kozepiskolaiJogviszonyXml = kozepiskolaiJogviszonyIterator.iterateNext();
                if (kozepiskolaiJogviszonyXml) {
                    hallgato.kozepiskolas = true;
                    hallgato.kozepiskolaiJogviszony.kozepiskolaNev = xml.evaluate('kozepiskolaNev', kozepiskolaiJogviszonyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    hallgato.kozepiskolaiJogviszony.kozepiskolaVaros = xml.evaluate('kozepiskolaVaros', kozepiskolaiJogviszonyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    if (logging) console.log('    Középiskolás: ' + hallgato.kozepiskolaiJogviszony.kozepiskolaNev + ' (' + hallgato.kozepiskolaiJogviszony.kozepiskolaVaros +')');
                }

                const jogviszonyIterator = xml.evaluate('felsooktatasiJogviszonyok/jogviszony', hallgatoXml, null, XPathResult.ANY_TYPE, null);
                let jogviszonyXml = jogviszonyIterator.iterateNext();
                let jogviszonyI = 1;
                while (jogviszonyXml) {
                    hallgato.kozepiskolas = false;
                    let jogviszony = this.createJogviszony(hallgato);

                    jogviszony.intezmenyKod = xml.evaluate('intezmenyKod', jogviszonyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    jogviszony.karKod = xml.evaluate('karKod', jogviszonyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    jogviszony.aktivFelevekSzama = xml.evaluate('aktivFelevekSzama', jogviszonyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    jogviszony.kepzesTipusa = xml.evaluate('kepzesTipusa', jogviszonyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    jogviszony.kepzesMunkarendje = xml.evaluate('kepzesMunkarendje', jogviszonyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    jogviszony.megkezdesEve = xml.evaluate('megkezdesEve', jogviszonyXml, null, XPathResult.STRING_TYPE, null).stringValue;

                    if (logging) console.log('    ' + jogviszonyI + '. jogviszony: ' + jogviszony.intezmenyKod +' '+ jogviszony.karKod +' '+ jogviszony.aktivFelevekSzama +' '+ jogviszony.kepzesTipusa);

                    jogviszonyXml = jogviszonyIterator.iterateNext();
                    jogviszonyI = jogviszonyI + 1;
                }

                hallgatoI = hallgatoI + 1
                hallgatoXml = hallgatoIterator.iterateNext();
            }

            const temavezetoIterator = xml.evaluate('temavezetok/temavezeto', palyamunkaXml, null, XPathResult.ANY_TYPE, null);
            let temavezetoXml = temavezetoIterator.iterateNext();
            let temavezetoI = 1;
            while (temavezetoXml) {
                let temavezeto = this.createTemavezeto(palyamunka);

                temavezeto.titulus = xml.evaluate('titulus', temavezetoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                temavezeto.vezetekNev = xml.evaluate('vezetekNev', temavezetoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                temavezeto.keresztNev = xml.evaluate('keresztNev', temavezetoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('  ' + temavezetoI + '. temavezeto: ' + temavezeto.titulus + ' ' + temavezeto.vezetekNev + ' ' + temavezeto.keresztNev);

                temavezeto.omAzon = xml.evaluate('omAzon', temavezetoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('    OmAzon:' + temavezeto.omAzon);

                temavezeto.email = xml.evaluate('email', temavezetoXml, null, XPathResult.STRING_TYPE, null).stringValue;
                if (logging) console.log('    E-mail:' + temavezeto.email);

                const munkahelyIterator = xml.evaluate('munkahelyek/*', temavezetoXml, null, XPathResult.ANY_TYPE, null);
                let munkahelyXml = munkahelyIterator.iterateNext();
                let munkahelyI = 1;
                while (munkahelyXml) {
                    if (munkahelyXml.nodeName == 'felsooktatasiMunkahely') {
                        let felsooktatasiMunkahely = this.createFelsooktatasiMunkahely(temavezeto);

                        felsooktatasiMunkahely.intezmenyKod = xml.evaluate('intezmenyKod', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                        felsooktatasiMunkahely.karKod = xml.evaluate('karKod', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                        felsooktatasiMunkahely.beosztas = xml.evaluate('beosztas', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;

                        if (logging) console.log('    ' + munkahelyI + '. munkahely (' + felsooktatasiMunkahely.tipus + '): ' + felsooktatasiMunkahely.intezmenyKod + ' ' + felsooktatasiMunkahely.karKod + ' ' + felsooktatasiMunkahely.beosztas);
                    }
                    if (munkahelyXml.nodeName == 'egyebMunkahely') {
                        let egyebMunkahely = this.createEgyebMunkahely(temavezeto);

                        egyebMunkahely.munkahelyNev = xml.evaluate('munkahelyNev', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                        egyebMunkahely.beosztas = xml.evaluate('beosztas', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;

                        if (logging) console.log('    ' + munkahelyI + '. munkahely (' + egyebMunkahely.tipus + '): ' + egyebMunkahely.munkahelyNev + ' ' + egyebMunkahely.beosztas);
                    }

                    munkahelyXml = munkahelyIterator.iterateNext();
                    munkahelyI = munkahelyI + 1;
                }

                temavezetoI = temavezetoI + 1;
                temavezetoXml = temavezetoIterator.iterateNext();
            }

            palyamunkaI = palyamunkaI + 1;
            palyamunkaXml = palyamunkaIterator.iterateNext();
        }

        jegyzokonyv.zsuritagok = []
        const zsuritagIterator = xml.evaluate('//zsuritag', xml, null, XPathResult.ANY_TYPE, null);
        let zsuritagXml = zsuritagIterator.iterateNext();
        let zsuritagI = 1;
        while (zsuritagXml) {
            let zsuritag = this.createZsuritag(jegyzokonyv);

            zsuritag.titulus = xml.evaluate('titulus', zsuritagXml, null, XPathResult.STRING_TYPE, null).stringValue;
            zsuritag.vezetekNev = xml.evaluate('vezetekNev', zsuritagXml, null, XPathResult.STRING_TYPE, null).stringValue;
            zsuritag.keresztNev = xml.evaluate('keresztNev', zsuritagXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log('  ' + zsuritagI + '. zsuritag: ' + zsuritag.titulus + ' ' + zsuritag.vezetekNev + ' ' + zsuritag.keresztNev);

            zsuritag.email = xml.evaluate('email', zsuritagXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log('    E-mail:' + zsuritag.email);

            const munkahelyIterator = xml.evaluate('munkahelyek/*', zsuritagXml, null, XPathResult.ANY_TYPE, null);
            let munkahelyXml = munkahelyIterator.iterateNext();
            let munkahelyI = 1;
            while (munkahelyXml) {
                if (munkahelyXml.nodeName == 'felsooktatasiMunkahely') {
                    let felsooktatasiMunkahely = this.createFelsooktatasiMunkahely(zsuritag);

                    felsooktatasiMunkahely.intezmenyKod = xml.evaluate('intezmenyKod', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    felsooktatasiMunkahely.karKod = xml.evaluate('karKod', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    felsooktatasiMunkahely.beosztas = xml.evaluate('beosztas', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;

                    if (logging) console.log('    ' + munkahelyI + '. munkahely ('+ felsooktatasiMunkahely.tipus +'): ' + felsooktatasiMunkahely.intezmenyKod + ' ' + felsooktatasiMunkahely.karKod + ' ' + felsooktatasiMunkahely.beosztas);
                }
                if (munkahelyXml.nodeName == 'egyebMunkahely') {
                    let egyebMunkahely = this.createEgyebMunkahely(zsuritag);

                    egyebMunkahely.munkahelyNev = xml.evaluate('munkahelyNev', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;
                    egyebMunkahely.beosztas = xml.evaluate('beosztas', munkahelyXml, null, XPathResult.STRING_TYPE, null).stringValue;

                    if (logging) console.log('    ' + munkahelyI + '. munkahely (' + egyebMunkahely.tipus +'): ' + egyebMunkahely.munkahelyNev + ' ' + egyebMunkahely.beosztas);
                }
                
                munkahelyXml = munkahelyIterator.iterateNext();
                munkahelyI = munkahelyI + 1;
            }

            zsuritagI = zsuritagI + 1;
            zsuritagXml = zsuritagIterator.iterateNext();
        }

        jegyzokonyv.loadResult = 'w';
        jegyzokonyv.loadMessage = 'Nem véglegesített jegyzőkönyv';
        var veglegesitesIdobelyeg = xml.evaluate('/tdkKonferencia/veglegesites/idobelyeg', xml, null, XPathResult.STRING_TYPE, null).stringValue;
        if (veglegesitesIdobelyeg) {
            if (logging) console.log("Veglegesitve:" + veglegesitesIdobelyeg);
            var veglegesitesCRC = xml.evaluate('/tdkKonferencia/veglegesites/crc', xml, null, XPathResult.STRING_TYPE, null).stringValue;
            jegyzokonyv.loadMessage = 'Véglegesített jegyzőkönyv (időbélyeg: '+ veglegesitesIdobelyeg;
            if (logging) console.log("CRC:" + veglegesitesCRC);
            let crc_start = text.lastIndexOf("<crc>");
            let crc_end = text.lastIndexOf("</crc>");
            let textWithoutCRC = text.substring(0, crc_start) + text.substring(crc_end + 6);

            let crcReCheck = b_crc32(textWithoutCRC);
            if (veglegesitesCRC == crcReCheck) {
                jegyzokonyv.loadResult = 's';
                jegyzokonyv.loadMessage = jegyzokonyv.loadMessage + ', ellenőrző kód megfelelő)';
            } else {
                jegyzokonyv.loadResult = 'e';
                jegyzokonyv.loadMessage = jegyzokonyv.loadMessage + ', ellenőrző kód hibás)';
            };
        };
    },

    escapeXml(unsafeString) {
        if (unsafeString == null || unsafeString == undefined || typeof unsafeString != 'string')
            return unsafeString;
        else
            return unsafeString
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&apos;");
    },

    addXmlElement(doc, parent, name, text) {
        if (text != "") {
            var element = doc.createElement(name);
            element.innerHTML = this.escapeXml(text);
            parent.appendChild(element);
        }
    },

    addXmlAttribute(doc, node, name, text) {
        if (text != "") {
            var attribute = doc.createAttribute(name);
            attribute.value = this.escapeXml(text);
            node.setAttributeNode(attribute);
        }
    },

    addXmlElementParent(doc, parent, name) {
        var element = doc.createElement(name);
        parent.appendChild(element);
        return element;
    },

    saveJegyzokonyvXml(validated) {
        var doc = document.implementation.createDocument("", "", null);
        var xmlTdkKonferencia = this.addXmlElementParent(doc, doc, "tdkKonferencia");
        this.addXmlAttribute(doc, xmlTdkKonferencia, "xmlns:xsd", "TDKJegyzokonyv.xsd");
        this.addXmlAttribute(doc, xmlTdkKonferencia, "xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
        this.addXmlAttribute(doc, xmlTdkKonferencia, "xsi:noNamespaceSchemaLocation", "https://tdkjegyzokonyv.otdk.hu/schema/20250707/TDKJegyzokonyv.xsd");

        var xmlKonferenciaAdatai = this.addXmlElementParent(doc, xmlTdkKonferencia, "konferenciaAdatai");
        this.addXmlElement(doc, xmlKonferenciaAdatai, "intezmenyiKonferencia", jegyzokonyv.intezmenyiKonferencia);
        this.addXmlElement(doc, xmlKonferenciaAdatai, "konferencia", jegyzokonyv.konferencia);
        this.addXmlElement(doc, xmlKonferenciaAdatai, "idopont", jegyzokonyv.idopont);
        this.addXmlElement(doc, xmlKonferenciaAdatai, "helyszin", jegyzokonyv.helyszin);
        this.addXmlElement(doc, xmlKonferenciaAdatai, "szekcio", jegyzokonyv.szekcio);
        this.addXmlElement(doc, xmlKonferenciaAdatai, "intezmenyKod", jegyzokonyv.intezmenyKod);
        this.addXmlElement(doc, xmlKonferenciaAdatai, "karKod", jegyzokonyv.karKod);
        this.addXmlElement(doc, xmlKonferenciaAdatai, "tanszek", jegyzokonyv.tanszek);
        this.addXmlElement(doc, xmlKonferenciaAdatai, "muhely", jegyzokonyv.muhely);

        var xmlPalyamunkak = this.addXmlElementParent(doc, xmlTdkKonferencia, "palyamunkak");
        for (var palyamunkaI = 0; palyamunkaI < jegyzokonyv.palyamunkak.length; palyamunkaI++)
        {
            var palyamunka = jegyzokonyv.palyamunkak[palyamunkaI];
            var xmlPalyamunka = this.addXmlElementParent(doc, xmlPalyamunkak, "palyamunka");
            this.addXmlElement(doc, xmlPalyamunka, "cim", palyamunka.cim);
            this.addXmlElement(doc, xmlPalyamunka, "nyelv", palyamunka.nyelv);
            if (palyamunka.osszesitettPontszam)
                this.addXmlElement(doc, xmlPalyamunka, "osszesitettPontszam", palyamunka.osszesitettPontszam);
            if (palyamunka.helyezes)
                this.addXmlElement(doc, xmlPalyamunka, "helyezes", palyamunka.helyezes);
            this.addXmlElement(doc, xmlPalyamunka, "otdkraJavasolt", palyamunka.otdkraJavasolt);
            if (palyamunka.affiliacioTipus == 'F') {
                var xmlFelsooktatasiAffiliacio = this.addXmlElementParent(doc, xmlPalyamunka, "felsooktatasiAffiliacio");
                this.addXmlElement(doc, xmlFelsooktatasiAffiliacio, "intezmenyKod", palyamunka.felsooktatasiAffiliacio.intezmenyKod);
                this.addXmlElement(doc, xmlFelsooktatasiAffiliacio, "karKod", palyamunka.felsooktatasiAffiliacio.karKod);
            }
            if (palyamunka.affiliacioTipus == 'K') {
                var xmlKozepiskolaiAffiliacio = this.addXmlElementParent(doc, xmlPalyamunka, "kozepiskolaiAffiliacio");
                this.addXmlElement(doc, xmlKozepiskolaiAffiliacio, "kozepiskolaProgram", palyamunka.kozepiskolaiAffiliacio.kozepiskolaProgram);
            }

            this.addXmlElement(doc, xmlPalyamunka, "zsuriMegjegyzes", palyamunka.zsuriMegjegyzes);
            this.addXmlElement(doc, xmlPalyamunka, "sorrendRelevans", palyamunka.sorrendRelevans);
            this.addXmlElement(doc, xmlPalyamunka, "aranyRelevans", palyamunka.aranyRelevans);

            var xmlSzerzok = this.addXmlElementParent(doc, xmlPalyamunka, "szerzok");
            for (var szerzoI = 0; szerzoI < palyamunka.szerzok.length; szerzoI++) {
                var hallgato = palyamunka.szerzok[szerzoI];
                var xmlHallgato = this.addXmlElementParent(doc, xmlSzerzok, "hallgato");
                this.addXmlElement(doc, xmlHallgato, "vezetekNev", hallgato.vezetekNev);
                this.addXmlElement(doc, xmlHallgato, "keresztNev", hallgato.keresztNev);
                this.addXmlElement(doc, xmlHallgato, "omAzon", hallgato.omAzon);
                this.addXmlElement(doc, xmlHallgato, "email", hallgato.email);
                this.addXmlElement(doc, xmlHallgato, "szerzosegiArany", hallgato.szerzosegiArany);

                if (hallgato.kozepiskolas) {
                    var xmlKozepiskolaiJogviszony = this.addXmlElementParent(doc, xmlHallgato, "kozepiskolaiJogviszony");
                    this.addXmlElement(doc, xmlKozepiskolaiJogviszony, "kozepiskolaNev", hallgato.kozepiskolaiJogviszony.kozepiskolaNev);
                    this.addXmlElement(doc, xmlKozepiskolaiJogviszony, "kozepiskolaVaros", hallgato.kozepiskolaiJogviszony.kozepiskolaVaros);
                } else {
                    var xmlFelsooktatasiJogviszonyok = this.addXmlElementParent(doc, xmlHallgato, "felsooktatasiJogviszonyok");
                    for (var jogviszonyI = 0; jogviszonyI < hallgato.felsooktatasiJogviszonyok.length; jogviszonyI++) {
                        var jogviszony = hallgato.felsooktatasiJogviszonyok[jogviszonyI];
                        var xmlJogviszony = this.addXmlElementParent(doc, xmlFelsooktatasiJogviszonyok, "jogviszony");

                        this.addXmlElement(doc, xmlJogviszony, "intezmenyKod", jogviszony.intezmenyKod);
                        this.addXmlElement(doc, xmlJogviszony, "karKod", jogviszony.karKod);
                        this.addXmlElement(doc, xmlJogviszony, "aktivFelevekSzama", jogviszony.aktivFelevekSzama);
                        this.addXmlElement(doc, xmlJogviszony, "kepzesTipusa", jogviszony.kepzesTipusa);
                        this.addXmlElement(doc, xmlJogviszony, "kepzesMunkarendje", jogviszony.kepzesMunkarendje);
                        this.addXmlElement(doc, xmlJogviszony, "megkezdesEve", jogviszony.megkezdesEve);
                    }
                }
            }

            var xmlTemavezetok = this.addXmlElementParent(doc, xmlPalyamunka, "temavezetok");
            for (var temavezetoI = 0; temavezetoI < palyamunka.temavezetok.length; temavezetoI++) {
                var temavezeto = palyamunka.temavezetok[temavezetoI];
                var xmlTemavezeto = this.addXmlElementParent(doc, xmlTemavezetok, "temavezeto");
                this.addXmlElement(doc, xmlTemavezeto, "titulus", temavezeto.titulus);
                this.addXmlElement(doc, xmlTemavezeto, "vezetekNev", temavezeto.vezetekNev);
                this.addXmlElement(doc, xmlTemavezeto, "keresztNev", temavezeto.keresztNev);
                this.addXmlElement(doc, xmlTemavezeto, "omAzon", temavezeto.omAzon);
                this.addXmlElement(doc, xmlTemavezeto, "email", temavezeto.email);

                var xmlMunkahelyek = this.addXmlElementParent(doc, xmlTemavezeto, "munkahelyek");
                for (var munkahelyI = 0; munkahelyI < temavezeto.munkahelyek.length; munkahelyI++) {
                    var munkahely = temavezeto.munkahelyek[munkahelyI];
                    if (munkahely.felsooktatas) {
                        var xmlFelsooktatasiMunkahely = this.addXmlElementParent(doc, xmlMunkahelyek, "felsooktatasiMunkahely");
                        this.addXmlElement(doc, xmlFelsooktatasiMunkahely, "beosztas", munkahely.beosztas);
                        this.addXmlElement(doc, xmlFelsooktatasiMunkahely, "intezmenyKod", munkahely.intezmenyKod);
                        this.addXmlElement(doc, xmlFelsooktatasiMunkahely, "karKod", munkahely.karKod);
                    } else {
                        var xmlEgyebMunkahely = this.addXmlElementParent(doc, xmlMunkahelyek, "egyebMunkahely");
                        this.addXmlElement(doc, xmlEgyebMunkahely, "beosztas", munkahely.beosztas);
                        this.addXmlElement(doc, xmlEgyebMunkahely, "munkahelyNev", munkahely.munkahelyNev);
                    }
                }
            }
        }

        var xmlZsuritagok = this.addXmlElementParent(doc, xmlTdkKonferencia, "zsuritagok");
        for (var zsuritagI = 0; zsuritagI < jegyzokonyv.zsuritagok.length; zsuritagI++) {
            var zsuritag = jegyzokonyv.zsuritagok[zsuritagI];
            var xmlZsuritag = this.addXmlElementParent(doc, xmlZsuritagok, "zsuritag");
            this.addXmlElement(doc, xmlZsuritag, "titulus", zsuritag.titulus);
            this.addXmlElement(doc, xmlZsuritag, "vezetekNev", zsuritag.vezetekNev);
            this.addXmlElement(doc, xmlZsuritag, "keresztNev", zsuritag.keresztNev);
            this.addXmlElement(doc, xmlZsuritag, "email", zsuritag.email);
            
            var xmlMunkahelyek = this.addXmlElementParent(doc, xmlZsuritag, "munkahelyek");
            for (var munkahelyI = 0; munkahelyI < zsuritag.munkahelyek.length; munkahelyI++) {
                var munkahely = zsuritag.munkahelyek[munkahelyI];
                if (munkahely.felsooktatas) {
                    var xmlFelsooktatasiMunkahely = this.addXmlElementParent(doc, xmlMunkahelyek, "felsooktatasiMunkahely");
                    this.addXmlElement(doc, xmlFelsooktatasiMunkahely, "beosztas", munkahely.beosztas);
                    this.addXmlElement(doc, xmlFelsooktatasiMunkahely, "intezmenyKod", munkahely.intezmenyKod);
                    this.addXmlElement(doc, xmlFelsooktatasiMunkahely, "karKod", munkahely.karKod);
                } else {
                    var xmlEgyebMunkahely = this.addXmlElementParent(doc, xmlMunkahelyek, "egyebMunkahely");
                    this.addXmlElement(doc, xmlEgyebMunkahely, "beosztas", munkahely.beosztas);
                    this.addXmlElement(doc, xmlEgyebMunkahely, "munkahelyNev", munkahely.munkahelyNev);
                }
            }
        }

        this.addXmlElement(doc, xmlTdkKonferencia, "program", this.app_name);

        var serializer = new XMLSerializer();
        if (validated) {
            var xmlVeglegesites = this.addXmlElementParent(doc, xmlTdkKonferencia, "veglegesites");
            this.addXmlElement(doc, xmlVeglegesites, "idobelyeg", new Date().toISOString());

            var xmlString = serializer.serializeToString(doc);
            var fullXml = '<?xml version="1.0" encoding="utf-8"?>' + xmlString;

            var crc = b_crc32(fullXml);
            this.addXmlElement(doc, xmlVeglegesites, "crc", crc.toString());
        }

        xmlString = serializer.serializeToString(doc);
        fullXml = '<?xml version="1.0" encoding="utf-8"?>' + xmlString;
        return fullXml;
    },

    filename() {
        var text = 'jegyzokonyv';
        if (jegyzokonyv.intezmenyKod != '')
            text = text + '_'+ jegyzokonyv.intezmenyKod;
        if (jegyzokonyv.karKod != '')
            text = text + '_' + jegyzokonyv.karKod;
        if (jegyzokonyv.idopont != '') {
            var idoText = jegyzokonyv.idopont.replaceAll('.', '-').replaceAll(' ', '').replaceAll(':', '-');
            if (idoText[idoText.length - 1] == '-')
                idoText = idoText.substring(0, idoText.length - 1);
            text = text + '_' + idoText + '.xml';
        }
            
        return text;
    },

    async getIntezmenyekJogviszony() {
        await this.lazyLoadIntezmenyekXml();
        return intezmenyekJogviszony;
    },

    async getIntezmenyekAffiliacio() {
        await this.lazyLoadIntezmenyekXml();
        return intezmenyekAffiliacio;
    },

    async getIntezmenyekKonferencia() {
        await this.lazyLoadIntezmenyekXml();
        return intezmenyekKonferencia;
    },

    async lazyLoadIntezmenyekXml() {
        if (!intezmenyekLoaded) {
            let data = await fetch('https://online.otdk.hu/api/institutes.xml');
            let text = await data.text();
            intezmenyekJogviszony = this.loadIntezmenyekXml(text, 'jogviszony');
            intezmenyekAffiliacio = this.loadIntezmenyekXml(text, 'affiliacio');
            intezmenyekKonferencia = this.loadIntezmenyekXml(text, 'konferencia');
            intezmenyekLoaded = true;
        }
    },

    loadIntezmenyekXml(text, filter) {
        let intezmenyek = [];
        let logging = false;
        let parser = new DOMParser();
        let xml = parser.parseFromString(text, "text/xml");

        const intezmenyIterator = xml.evaluate('//intezmeny', xml, null, XPathResult.ANY_TYPE, null);
        let intezmenyXml = intezmenyIterator.iterateNext();
        while (intezmenyXml) {
            let intezmeny = {};
            intezmeny.karok = [];
            
            intezmeny.kod = xml.evaluate('@kod', intezmenyXml, null, XPathResult.STRING_TYPE, null).stringValue;
            intezmeny.nev = xml.evaluate('@nev', intezmenyXml, null, XPathResult.STRING_TYPE, null).stringValue;
            if (logging) console.log('intezmeny[' + intezmeny.kod + ']: ' + intezmeny.nev);
            intezmeny.jogviszony = xml.evaluate('@jogviszony', intezmenyXml, null, XPathResult.STRING_TYPE, null).stringValue;
            intezmeny.affiliacio = xml.evaluate('@affiliacio', intezmenyXml, null, XPathResult.STRING_TYPE, null).stringValue;
            intezmeny.konferencia = xml.evaluate('@konferencia', intezmenyXml, null, XPathResult.STRING_TYPE, null).stringValue;

            const karIterator = xml.evaluate('kar', intezmenyXml, null, XPathResult.ANY_TYPE, null);
            let karXml = karIterator.iterateNext();
            while (karXml) {
                let kar = {};

                kar.kod = xml.evaluate('@kod', karXml, null, XPathResult.STRING_TYPE, null).stringValue;
                kar.nev = xml.evaluate('@nev', karXml, null, XPathResult.STRING_TYPE, null).stringValue;
                kar.jogviszony = xml.evaluate('@jogviszony', karXml, null, XPathResult.STRING_TYPE, null).stringValue;
                kar.affiliacio = xml.evaluate('@affiliacio', karXml, null, XPathResult.STRING_TYPE, null).stringValue;
                kar.konferencia = xml.evaluate('@konferencia', karXml, null, XPathResult.STRING_TYPE, null).stringValue;

                if (logging) console.log('  kar[' + kar.kod + ']: ' + kar.nev);
                if ((filter == 'jogviszony' && kar.jogviszony == 'true') ||
                    (filter == 'affiliacio' && kar.affiliacio == 'true') ||
                    (filter == 'konferencia' && kar.konferencia == 'true'))
                    intezmeny.karok.push(kar);
                karXml = karIterator.iterateNext();
            }

            intezmenyXml = intezmenyIterator.iterateNext();

            if ((filter == 'jogviszony' && intezmeny.jogviszony == 'true') ||
                (filter == 'affiliacio' && intezmeny.affiliacio == 'true') ||
                (filter == 'konferencia' && intezmeny.konferencia == 'true'))
                intezmenyek.push(intezmeny);
        }
        return intezmenyek;
    },

    isValid() {
        return this.validationDetails().length == 0;
    },

    validationDetails() {
        errorLog = [];
        let container = 'Konferencia adatok';
        this.mandatoryText(container, "Intézmény", jegyzokonyv.intezmenyKod);
        this.mandatoryText(container, "TDK-konferencia tagozat", jegyzokonyv.konferencia);
        this.mandatoryText(container, "Konferencia időpontja", jegyzokonyv.idopont);
        this.mandatoryText(container, "Konferencia helyszíne", jegyzokonyv.helyszin);

        if (jegyzokonyv.zsuritagok.length == 0)
            this.error("Zsűritagok", "Legalább egy zsűritag felvétele szükséges");

        for (var zsuritagI = 0; zsuritagI < jegyzokonyv.zsuritagok.length; zsuritagI++) {
            var zsuritag = jegyzokonyv.zsuritagok[zsuritagI];
            container = (zsuritagI + 1) + '. zsűritag';
            this.mandatoryText(container, "Vezetékneve", zsuritag.vezetekNev);
            this.mandatoryText(container, "Keresztneve", zsuritag.keresztNev);
            this.mandatoryEmail(container, "E-mail címe", zsuritag.email);

            for (var munkahelyI = 0; munkahelyI < zsuritag.munkahelyek.length; munkahelyI++) {
                var munkahely = zsuritag.munkahelyek[munkahelyI];
                container = (zsuritagI + 1) + '. zsűritag ' + (munkahelyI + 1) +'. munkahelye';
                if (munkahely.felsooktatas) {
                    this.mandatoryText(container, "Beosztás", munkahely.beosztas);
                    this.mandatoryText(container, "Felsőoktatási intézmény", munkahely.intezmenyKod);
                } else {
                    this.mandatoryText(container, "Beosztás", munkahely.beosztas);
                    this.mandatoryText(container, "Munkahely neve", munkahely.munkahelyNev);
                }
            }
        }

        for (var palyamunkaI = 0; palyamunkaI < jegyzokonyv.palyamunkak.length; palyamunkaI++) {
            var palyamunka = jegyzokonyv.palyamunkak[palyamunkaI];
            container = (palyamunkaI + 1) + '. előadás';
            this.mandatoryText(container, "OTDK-ra javasolt", palyamunka.otdkraJavasolt);
            this.mandatoryText(container, "A TDK-pályamunka címe", palyamunka.cim);
            this.mandatoryText(container, "Pályamunka nyelve", palyamunka.nyelv);
            if (palyamunka.affiliacioTipus == 'F') {
                this.mandatoryText(container, "Felsőoktatási affiliáció - Intézmény", palyamunka.felsooktatasiAffiliacio.intezmenyKod);
            } else
                if (palyamunka.affiliacioTipus == 'K') {
                    this.mandatoryText(container, "Középiskolai affiliáció - Középiskolás program", palyamunka.kozepiskolaiAffiliacio.kozepiskolaProgram);
                } else
                    this.error(container, "Affiliació", "Nincs kitöltve");

            this.mandatoryText(container, "Több szerző esetén a a szerzők sorrendje releváns", palyamunka.sorrendRelevans);
            this.mandatoryText(container, "Több szerző esetén a a szerzőségi arány releváns", palyamunka.aranyRelevans);

            for (var szerzoI = 0; szerzoI < palyamunka.szerzok.length; szerzoI++) {
                var hallgato = palyamunka.szerzok[szerzoI];
                container = (palyamunkaI + 1) + '. előadás ' + (szerzoI + 1) + '. szerzője';
                this.mandatoryText(container, "Vezetékneve", hallgato.vezetekNev);
                this.mandatoryText(container, "Keresztneve", hallgato.keresztNev);
                this.checkOmAzon(container, "Oktatási azonosító száma", hallgato.omAzon);
                this.mandatoryEmail(container, "E-mail címe", hallgato.email);

                if (hallgato.kozepiskolas) {
                    this.mandatoryText(container, "Középiskola neve", hallgato.kozepiskolaiJogviszony.kozepiskolaNev);
                    this.mandatoryText(container, "Középiskola városa", hallgato.kozepiskolaiJogviszony.kozepiskolaVaros);
                } else {
                    if (hallgato.felsooktatasiJogviszonyok.length == 0) {
                        container = (palyamunkaI + 1) + '. előadás ' + (szerzoI + 1) + '. szerzője';
                        this.error(container, "Jogviszony", "Legalább egy középiskolai vagy felsőoktatási jogviszony szükséges");
                    }
                    for (var jogviszonyI = 0; jogviszonyI < hallgato.felsooktatasiJogviszonyok.length; jogviszonyI++) {
                        var jogviszony = hallgato.felsooktatasiJogviszonyok[jogviszonyI];
                        container = (palyamunkaI + 1) + '. előadás ' + (szerzoI + 1) + '. szerzőjének' + ' ' + (jogviszonyI + 1) + '. jogviszonya';
                        this.mandatoryText(container, "Intézmény", jogviszony.intezmenyKod);
                        this.mandatoryText(container, "Aktív félévek", jogviszony.aktivFelevekSzama);
                        this.mandatoryText(container, "Típusa", jogviszony.kepzesTipusa);
                        this.mandatoryText(container, "Munkarendje", jogviszony.kepzesMunkarendje);
                        this.mandatoryText(container, "Megkezdés éve", jogviszony.megkezdesEve);
                    }
                }
            }

            for (var temavezetoI = 0; temavezetoI < palyamunka.temavezetok.length; temavezetoI++) {
                var temavezeto = palyamunka.temavezetok[temavezetoI];
                container = (palyamunkaI + 1) + '. előadás ' + (temavezetoI + 1) + '. témavezetője';
                this.mandatoryText(container, "Vezetékneve", temavezeto.vezetekNev);
                this.mandatoryText(container, "Keresztneve", temavezeto.keresztNev);
                this.checkOmAzon(container, "Oktatási azonosító száma", temavezeto.omAzon);
                this.mandatoryEmail(container, "E-mail címe", temavezeto.email);

                if (temavezeto.munkahelyek.length == 0) {
                    this.error(container, "Munkahelyek", "Legalább egy munkahely szükséges");
                }
                for (var munkahelyI = 0; munkahelyI < temavezeto.munkahelyek.length; munkahelyI++) {
                    var munkahely = temavezeto.munkahelyek[munkahelyI];
                    container = (palyamunkaI + 1) + '. előadás ' + (temavezetoI + 1) + '. témavezetőjének ' +(munkahelyI + 1) +'. munkahelye';
                    if (munkahely.felsooktatas) {
                        this.mandatoryText(container, "Beosztás", munkahely.beosztas);
                        this.mandatoryText(container, "Felsőoktatási intézmény", munkahely.intezmenyKod);
                    } else {
                        this.mandatoryText(container, "Beosztás", munkahely.beosztas);
                        this.mandatoryText(container, "Munkahely neve", munkahely.munkahelyNev);
                    }
                }
            }
        }

        return errorLog;
    },

    mandatoryText(container, fieldName, fieldValue) {
        if (fieldValue == null || fieldValue == undefined || fieldValue.length == 0)
            errorLog.push("A(z) '"+ container +"' rész '" + fieldName + "' mezője nem lehet üres");
    },

    checkOmAzon(container, fieldName, fieldValue) {
        if (fieldValue != null && fieldValue != undefined && fieldValue != '') {
            const omRegex = /^\d{11}$/;
            if (!omRegex.test(fieldValue.trim()))
                errorLog.push("A(z) '" + container + "' rész '" + fieldName + "' mezőjének 11 számjegynek kell lennie");
        }
    },

    mandatoryEmail(container, fieldName, fieldValue) {
        if (fieldValue == null || fieldValue == undefined || fieldValue.length == 0)
            errorLog.push("A(z) '"+ container +"' rész '" + fieldName + "' mezője nem lehet üres");
        else {
            const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
            if (!emailRegex.test(fieldValue.trim()))
                errorLog.push("A(z) '"+ container +"' rész '" + fieldName + "' mezője nem érvényes e-mail cím");
        }
    },

    error(container, fieldName, errorText) {
        errorLog.push("A(z) '" + container + "' rész '" + fieldName + "' mezője hibás: '" + errorText +"'");
    },

    error(container, errorText) {
        errorLog.push("A(z) '" + container + "' rész hibás: '" + errorText + "'");
    }
}

var a_table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
var b_table = a_table.split(' ').map(function (s) { return parseInt(s, 16) });
function b_crc32(str) {
    var crc = -1;
    for (var i = 0, iTop = str.length; i < iTop; i++) {
        crc = (crc >>> 8) ^ b_table[(crc ^ str.charCodeAt(i)) & 0xFF];
    }
    return (crc ^ (-1)) >>> 0;
};
